// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__CP3E9","avatar":"style_avatar__HzgTc","menuIcon":"style_menuIcon__17ffy"};